import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { Link } from 'react-router-dom';
import MyProfileAvatar from '../../../images/myProfileAvatar.png';
import PhoneIcon from '../../../images/myProfileIcon.png';
import LocationIcon from '../../../images/myProfileIcon2.png';
import FStarIcon from '../../../images/myProfileIcon3.png';
import EStarIcon from '../../../images/myProfileIcon4.png';
import Calender from '../../../images/myProfileCalender.png';
import True from '../../../images/true.png';
import WTrue from '../../../images/WTrue.png';
import False from '../../../images/false.png';


const MyProfile = () => {
  const [height, setHeight] = useState(0);

  const Row = ({ timing, mon, tue, wed, thu, fri, sat }) => {
    return <tr className="patient_hr">
      <td className="timing">{timing}</td>
      <td><img src={mon ? True : False } alt="icon" /></td>
      <td><img src={tue ? True : False } alt="icon" /></td>
      <td><img src={wed ? True : False } alt="icon" /></td>
      <td><img src={thu ? True : False } alt="icon" /></td>
      <td><img src={fri ? True : False } alt="icon" /></td>
      <td><img src={sat ? True : False } alt="icon" /></td>
  
    </tr>
  }
  return (
    <div>
      <Header setHeight={setHeight} />
      <div
        className="profile_crumb"
        style={{ height: height + 10 + "px" }}
      ></div>
      <div className="profile_page pb-5">
        <section className="py-5">  
       
        {/* Tabs Mobile View */}
            <div className="tabs_wrapper hide_on_large">
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="activeTab"><Link to="/" aria-controls="home" role="tab" data-toggle="tab">Intro & Schedule</Link></li>
                <li role="presentation"><Link to="/" aria-controls="profile" role="tab" data-toggle="tab">Patient Reviews</Link></li>
                <li role="presentation"><Link to="/" aria-controls="messages" role="tab" data-toggle="tab">Consultation Q&A</Link></li>
              </ul>
            </div>
          <div className="container mt-5">
            <div className="bg-white shadow myProfileHeader mx-auto">
              <img src={MyProfileAvatar} className="myProfileAvatar" alt="avatar" />
              <div className="myProfileHeaderInfo">
                <h3>Andrew Fallis</h3>
                <h5>Primary Care Doctor</h5>
                <div className="locationPhone">
                  <span className="mr-4"><img src={LocationIcon} alt="Location Icon" /> New York </span>
                  <span> <img src={PhoneIcon} alt="Phone Icon" /> +8802 123 4567</span>
                </div>
              </div>
              <div className="myProfileHeaderRating">
                <span className="reviewRating">
                  <h5>100 Reviews</h5>
                  <span><img src={FStarIcon} alt="star" /> <img src={FStarIcon} alt="star" /> <img src={FStarIcon} alt="star" />&ensp;
                     <img src={EStarIcon} alt="star" /> <img src={EStarIcon} alt="star" /> </span>
                </span>
                <span><button className="myProfileButton">BOOk AN APPOINTMENT</button></span>
              </div>
            </div>
            
            <div className="myProfileBody py-5 mx-auto">
             
             {/* Tabs in Desktop view */}
                <ul className="hide_on_med nav nav-tabs nav-justified nav-tabs-dropdown" role="tablist">
                  <li role="presentation" className="activeTab"><Link to="/" aria-controls="home" role="tab" data-toggle="tab">Intro & Schedule</Link></li>
                  <li role="presentation"><Link to="/" aria-controls="profile" role="tab" data-toggle="tab">Patient Reviews</Link></li>
                  <li role="presentation"><Link to="/" aria-controls="messages" role="tab" data-toggle="tab">Consultation Q&A</Link></li>
                </ul>
              <div className="myProfileAbout">
                <div className="row aboutRow">
                  <div className="col-lg-4 col-md-12 col-sm-12">
                    <h3 className="aboutTitle">About me</h3>
                  </div>
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <span className="aboutDesc aboutMe">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </span>
                  </div>
                </div>

                <div className="row aboutRow">
                  <div className="col-lg-4 ">
                    <h3 className="aboutTitle">Education</h3>
                  </div>
                  <div className="col-lg-8 aboutDesc aboutEducation">
                    <div className="row">
                      <div className="col-lg-6">- MBBS - Sawai Mansingh Medical College, Jaipur (SMS College), 2000</div>
                      <div className="col-lg-6">- MD - General Medicine - Jaslok Hospital and Research Centre, 2007</div>
                    </div>
                  </div>
                </div>

                <div className="row aboutRow">
                  <div className="col-lg-4 ">
                    <h3 className="aboutTitle">Specializations</h3>
                  </div>
                  <div className="col-lg-8 aboutDesc aboutSpecialization" >
                    <span>
                      General Physician <br />
                      Consultant Physician <br />
                      Internal Medicine
                    </span>
                  </div>
                </div>
              </div>
     
              <h2 className="availCalender py-4">
              <img src={Calender} className="hide_on_med" alt="calender" /><span className="ml-3"> Availability Calender</span></h2>
              <div className="cus_table">
                <table className="table ">
                  <thead>
                    <tr className="cus_head">
                      <th>Timing</th>
                      <th>Mon</th>
                      <th>Tue</th>
                      <th>Wed</th>
                      <th>Thu</th>
                      <th>Fri</th>
                      <th>Sat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <Row timing="8:00PM" mon={true} tue={false} wed={false} thu={true} fri={true} sat={true} />
                    <Row timing="8:30PM" mon={false} tue={true} wed={true} thu={true} fri={true} sat={true} />
                    <Row timing="9:00PM" mon={true} tue={true} wed={true} thu={true} fri={true} sat={true} />
                    <tr className="patient_hr">
                      <td className="timing">6:00PM</td>
                      <td><img src={False} alt="no" /></td>
                      <td><img src={True} alt="yes" /></td>
                      <td style={{ position: "relative", backgroundColor: "#25BCA7"}} >
                        <img src={WTrue} alt="yes" />
                        <div className="cellModal">
                          <span className="cellModalDay">Wednesday</span>
                          <span className="cellModalTime">6:00 PM</span>
                          <button className="cellModalButton btn font-weight-bold btn-theme text-uppercase font-smaller py-2 px-3 btn-dark">
                            Book an appointment</button>
                        </div>
                        </td>
                      <td><img src={True} alt="yes" /></td>
                      <td><img src={False} alt="no" /></td>
                      <td><img src={True} alt="yes" /></td>
                    </tr>
                    
                    <Row timing="9:30PM" mon={true} tue={false} wed={true} thu={true} fri={true} sat={true} />
                    <Row timing="10:00PM" mon={true} tue={false} wed={false} thu={true} fri={true} sat={true} />
                    <Row timing="10:30PM" mon={false} tue={true} wed={true} thu={true} fri={false} sat={true} />
                    <Row timing="11:00PM" mon={true} tue={false} wed={true} thu={false} fri={true} sat={true} />
                    <Row timing="11:30PM" mon={true} tue={true} wed={true} thu={true} fri={true} sat={true} />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div >
  );
};

export default MyProfile;
